import { z } from "zod";
import { QUICK_LOGIN_TEST_ACCOUNTS } from "./quick-login/accounts";

const EmailSchema = z
  .string({
    required_error: "Required"
  })
  .trim()
  .email({
    message: "Must be a valid email"
  });

export const UserAuthSchema = z.object({
  email: EmailSchema,
  password: z
    .string({
      required_error: "Required"
    })
    .min(8, {
      message: "Password must be at least 8 characters"
    }),
  turnstileToken: z
    .string({
      required_error: "Please complete the security check"
    })
    .min(1, {
      message: "Please complete the security check"
    })
    .max(2048, {
      message: "Invalid security check"
    })
});

export const PasswordResetSchema = z.object({
  email: EmailSchema
});

export const PasswordUpdateSchema = z.object({
  password: z.string({
    required_error: "Required"
  })
});

export const MagicLinkSchema = z.object({
  email: EmailSchema
});

export const OTPVerificationSchema = z.object({
  email: EmailSchema,
  token: z
    .string({
      required_error: "Required"
    })
    .length(6, {
      message: "OTP must be 6 digits"
    })
    .regex(/^\d+$/, {
      message: "OTP must contain only numbers"
    })
});

export type UserAuthSchema = z.infer<typeof UserAuthSchema>;
export type PasswordResetSchema = z.infer<typeof PasswordResetSchema>;
export type PasswordUpdateSchema = z.infer<typeof PasswordUpdateSchema>;
export type MagicLinkSchema = z.infer<typeof MagicLinkSchema>;
export type OTPVerificationSchema = z.infer<typeof OTPVerificationSchema>;

const quickLoginTestEmails = QUICK_LOGIN_TEST_ACCOUNTS.map(
  account => account.email
);

export const QuickLoginSchema = z.object({
  email: z.enum(quickLoginTestEmails as [string, ...string[]], {
    required_error: "Required"
  })
});

export type QuickLoginSchema = z.infer<typeof QuickLoginSchema>;
